import emptySplitApi from "../utils/rtk";
import { CommonBody, DocumentList } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetDocumentsResponse = {
  length: number;
  start: number;
  response_object: DocumentList[];
  total_records: number;
  from_date?: string;
  to_date?: string;
};

export const documentsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDocuments: builder.mutation<
      CommonResponseType & { data: GetDocumentsResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getAllDocuments,
        method: "POST",
        body,
      }),
    }),

    deleteDocument: builder.query<
      CommonResponseType & { data: DocumentList },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteDocument}${id}/`,
        method: "DELETE",
      }),
    }),

    documentDetails: builder.query<
      CommonResponseType & { data: DocumentList | null },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.documentById}${id}/`,
        method: "GET",
      }),
    }),
    updateDocument: builder.mutation<
      CommonResponseType & { data: DocumentList },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateDocument}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    addDocument: builder.mutation<
      CommonResponseType & { data: DocumentList },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addDocument,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetDocumentsMutation,
  useLazyDeleteDocumentQuery,
  useLazyDocumentDetailsQuery,
  useUpdateDocumentMutation,
  useAddDocumentMutation,
} = documentsApi;
